import bugsnagVue from '@bugsnag/plugin-vue';
import bugsnag from '@bugsnag/js';
import Vue from 'vue';

const bugsnagClient = bugsnag('2368a552a5349d23ee1baab11d65710a');

bugsnagClient.use(bugsnagVue, Vue);
export default bugsnagClient;
